export const logout = (auth) => {
    auth.logout({ returnTo: window.location.origin })
}
